import { render, staticRenderFns } from "./ServicoListFiltroModalItemInputTransportadoras.vue?vue&type=template&id=456a3eaa"
import script from "./ServicoListFiltroModalItemInputTransportadoras.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltroModalItemInputTransportadoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports